import { createContext, useMemo } from 'react';
import { useLocation, useNavigate} from 'react-router-dom';
import PATH from '../utils/Paths';

const RouteContext = createContext();

export const RouteContextProvider  = ({children}) => {

    //location     
    const location = useLocation();    

    const routeName = useMemo( () => {
        let barrpos=location.pathname.lastIndexOf('/')
        return String(location.pathname.slice(0, barrpos>0?barrpos:location.length))
    },[location])

    const rotaVotacao= useMemo(()=>{
        return routeName===PATH.VOTACAO
    },[routeName])

    const rotaSecoes= useMemo(()=>{
        return routeName===PATH.SECOES
    },[routeName])

    const rotaAcompanhamento= useMemo(()=>{
        return routeName===PATH.ACOMPANHAMENTO
    },[routeName])

    const rotaMapa= useMemo(()=>{
        return routeName===PATH.MAPA
    },[routeName])

    const rotaPendencias= useMemo(()=>{
        return routeName===PATH.PENDENCIAS
    },[routeName])

    const rotaLogin= useMemo(()=>{
        return routeName===PATH.LOGIN
    },[routeName])

    const rotaError= useMemo(()=>{
        return (!rotaAcompanhamento && !rotaSecoes && !rotaVotacao && !rotaPendencias && !rotaLogin)
    },[routeName])

    return(
        <RouteContext.Provider value={{routeName, rotaVotacao, rotaSecoes, rotaAcompanhamento, rotaMapa, rotaPendencias, rotaLogin, rotaError}}>
            {children}
        </RouteContext.Provider>
    );
}

export default RouteContext